import { Divider, VStack } from '@cad-arc';
import { useRunUnitHistorySearchOnChange } from '../../hooks/use-run-unit-history-search-on-change';
import { IncludedEvents } from './included-events';
import { UnitHistorySearchForm } from './unit-history-search-form';
import { useApplicationType } from '../../../common/hooks/use-application-type';

export function UnitHistoryLeftPane({
    resultsScrollElementRef,
}: {
    resultsScrollElementRef: React.RefObject<HTMLDivElement>;
}): React.ReactElement {
    useRunUnitHistorySearchOnChange();
    const { isFirstResponder } = useApplicationType();

    return (
        <VStack
            paddingTop="16px"
            align="left"
            h="100%"
            gap="8px"
            {...(isFirstResponder
                ? { width: '50%' }
                : {
                      minWidth: '266px',
                      maxWidth: '266px',
                  })}
        >
            <UnitHistorySearchForm />
            <Divider style={{ width: 'calc(100% - 32px)', marginLeft: '16px' }} />
            <IncludedEvents resultsScrollElementRef={resultsScrollElementRef} />
        </VStack>
    );
}
